import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewPageComponent } from './preview-page.component';
import { SectionDetailsModule } from './components/section-details/section-details.module';
import { SectionHeaderGapModule } from '../section-header-gap/section-header-gap.module';

@NgModule({
  declarations: [PreviewPageComponent],
  imports: [CommonModule, SectionHeaderGapModule, SectionDetailsModule],
})
export class PreviewPageModule {}
